<template>
  <div class="container mt-5 p-0 bg-transparent rounded">
    <div class="text-center mb-4">
      <h1 class="mb-2">📋 Students Profile</h1>
      <!-- <div class="d-flex justify-content-center gap-3">
        <span class="badge bg-primary">Institute ID: {{ instituteId }}</span>
        <span class="badge bg-secondary">Token: {{ token }}</span>
      </div> -->
    </div>

    <!-- Filters Section -->
    <div class="row g-3 mb-4">
      <div class="col-md-4">
        <label for="subject" class="form-label fw-bold">Select Subject</label>
        <select v-model="selectedSubject" class="form-select" id="subject">
          <option value="">-- All Subjects --</option>
          <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
            {{ subject.name }}
          </option>
        </select>
      </div>

      <div class="col-md-4">
        <label for="grade" class="form-label fw-bold">Select Grade</label>
        <select v-model="selectedGrade" class="form-select" id="grade">
          <option value="">-- All Grades --</option>
          <option v-for="grade in grades" :key="grade.id" :value="grade.id">
            {{ grade.grade_level }}
          </option>
        </select>
      </div>

      <div class="col-md-4">
        <label class="form-label fw-bold">Search by Student Code</label>
        <input
          type="text"
          class="form-control"
          placeholder="Search e.g. WAVE123"
          v-model="searchWaveCode"
          @input="fetchStudents"
        />
      </div>
    </div>

    <!-- Student Info & Table -->
    <div class="table-responsive">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h2 class="mb-0">👨‍🎓 Students List</h2>
        <div>
          <span class="badge bg-info text-dark me-2">Filtered: {{ totalStudents }}</span>
          <span class="badge bg-success">Total in Institute: {{ totalAllStudents }}</span>
        </div>
      </div>

      <!-- Loading Spinner -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Table -->
      <table v-if="students.length && !loading" class="table table-bordered table-hover">
        <thead class="table-dark text-center">
          <tr>
            <th class="mobile">#</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Gender</th>
            <th>Grade</th>
            <th>Subjects</th>
            <th>Wave Codes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, index) in students" :key="student.id">
            <td class="text-center mobile">{{ index + 1 }}</td>
            <td>{{ student.first_name }}</td>
            <td>{{ student.last_name }}</td>
            <td>{{ student.gender }}</td>
            <td>{{ student.grade?.grade_level || 'N/A' }}</td>
            <td>
  <div class="cell-rows">
    <div class="row-box" v-for="(item, idx) in student.student_items" :key="`subject-${idx}`">
      {{ item.subject?.name || 'N/A' }}
    </div>
  </div>
</td>
<td>
  <div class="cell-rows">
    <div class="row-box" v-for="(item, idx) in student.student_items" :key="`wave-${idx}`">
      {{ item.student_code?.wave_code || 'N/A' }}
    </div>
  </div>
</td>

          </tr>
        </tbody>
      </table>

      <p v-else-if="!loading" class="text-center text-danger fs-5">
        No students found for this institute.
      </p>
    </div>

    <!-- Pagination -->
<div v-if="totalPages > 1" class="d-flex justify-content-center mt-4 flex-wrap">
  <nav>
    <ul class="pagination flex-wrap">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
      </li>

      <li
        class="page-item"
        v-for="page in totalPages"
        :key="page"
        :class="{ active: currentPage === page }"
      >
        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
      </li>

      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
      </li>
    </ul>
  </nav>
</div>

  </div>
</template>


<script>
import axios from 'axios';

export default {
  data() {
    return {
      instituteId: null,
      token: null,
      students: [],
      subjects: [],
      selectedSubject: '',
      grades: [],
      selectedGrade: '',
      searchWaveCode: '',
      loading: false,
      currentPage: 1,
totalPages: 1,
perPage: 2,
totalAllStudents: 0,


    };
  },

  created() {
    this.instituteId = localStorage.getItem('institute_id');
    this.token = localStorage.getItem('token');
    this.fetchSubjects();
    this.fetchGrades(); // Fetch grades on creation if instituteId exists

    if (this.instituteId) {
      this.fetchStudents();
    }
  },

  watch: {
    selectedSubject() {
      this.fetchStudents(); // Re-fetch students when subject filter changes
    },
    selectedGrade() {
      this.fetchStudents(); // Re-fetch students when grade filter changes
    },
  },

  methods: {
    async fetchStudents() {
  this.loading = true;
  try {
    const response = await axios.get(
      `getInstituteStudents/${this.instituteId}`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
        params: {
          subject_id: this.selectedSubject || undefined,
          grade_id: this.selectedGrade || undefined,
          wave_code: this.searchWaveCode || undefined,
          page: this.currentPage,
          per_page: this.perPage,
        },
      }
    );

    this.students = response.data.data;
    this.totalPages = response.data.last_page;
    this.totalStudents = response.data.total;
this.totalAllStudents = response.data.total_all_students; // 👈 New
  } catch (error) {
    console.error('Error fetching students:', error.response?.data || error.message);
    this.students = [];
    this.totalPages = 1;
  } finally {
    this.loading = false;
  }
},

    fetchSubjects() {
      axios
        .get('/get-subjects-by-institute', {
          params: { institute_id: this.instituteId },
        })
        .then((response) => {
          this.subjects = response.data;
        })
        .catch((error) => {
          console.error('Error fetching subjects:', error);
        });
    },

    fetchGrades() {
      axios
        .get('/get-grades-by-institute', {
          params: { institute_id: this.instituteId },
        })
        .then((response) => {
          this.grades = response.data;
        })
        .catch((error) => {
          console.error('Error fetching grades:', error);
        });
    },
    changePage(page) {
  if (page >= 1 && page <= this.totalPages) {
    this.currentPage = page;
    this.fetchStudents();
  }
}

  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  max-width: 1200px;
  background-color: #f8f9fa;
}
.table th,
.table td {
  vertical-align: middle;
}

.pagination .page-link {
  cursor: pointer;
}

h2 {
  font-size: 1.5rem;
  font-weight: 600;
}

.cell-rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.row-box {
  background-color: #f1f1f1;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .container {
  max-width: 300px;
  padding: 0 0px;
}

.mobile{
  display: none;
}

}


</style>
